// extracted by mini-css-extract-plugin
export var actionButton = "_i4-0";
export var fileInput = "_i4-2";
export var paperclip = "_i4-1";